module.exports = __webpack_public_path__ + "img/56.76be39b3.png";